export default __webpack_public_path__ + "static/media/location.a935a436.svg";